"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeeklyCalendar;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../libs/hooks");

var _hooks2 = require("./hooks");

var _helpers = require("./helpers");

var _Select = _interopRequireDefault(require("../Select"));

var _rightArrow = _interopRequireDefault(require("./icons/rightArrow"));

var _leftArrow = _interopRequireDefault(require("./icons/leftArrow"));

var _header = _interopRequireDefault(require("./header"));

var _week = _interopRequireDefault(require("./week"));

var _hours = _interopRequireDefault(require("./hours"));

var _container = _interopRequireDefault(require("./styled/container"));

var _content = _interopRequireDefault(require("./styled/content"));

var _controls = _interopRequireDefault(require("./styled/controls"));

var _title = _interopRequireDefault(require("./styled/title"));

var _arrowButton = _interopRequireDefault(require("./styled/arrowButton"));

var _gradient = _interopRequireDefault(require("./styled/gradient"));

function WeeklyCalendar(props) {
  var events = props.events,
      currentWeek = props.currentWeek,
      minDate = props.minDate,
      maxDate = props.maxDate,
      localLocale = props.locale,
      onWeekChange = props.onWeekChange,
      onEventClick = props.onEventClick,
      className = props.className,
      style = props.style;
  var locale = (0, _hooks.useLocale)(localLocale);
  var hoursRef = (0, _react.useRef)();
  var daysRef = (0, _react.useRef)();
  var week = (0, _hooks2.useCurrentWeek)(currentWeek);
  var formattedWeek = (0, _hooks2.useFormattedWeek)(week, locale);

  var _useState = (0, _react.useState)(new Date()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      today = _useState2[0],
      setToday = _useState2[1];

  var yearsRange = (0, _hooks2.useYearRange)(minDate, maxDate, week);

  var _useDisabledControls = (0, _hooks2.useDisabledControls)(yearsRange, week, minDate, maxDate),
      _useDisabledControls2 = (0, _slicedToArray2["default"])(_useDisabledControls, 2),
      isDisableNext = _useDisabledControls2[0],
      isDisablePrevious = _useDisabledControls2[1];

  var selectPreviousWeek = function selectPreviousWeek() {
    var newWeek = (0, _helpers.addWeeks)(week, -1);
    newWeek.setHours(0, 0, 0, 0);
    return onWeekChange({
      week: newWeek
    });
  };

  var selectNextWeek = function selectNextWeek() {
    var newWeek = (0, _helpers.addWeeks)(week, 1);
    newWeek.setHours(0, 0, 0, 0);
    return onWeekChange({
      week: newWeek
    });
  };

  var handleYearChange = function handleYearChange(event) {
    var newWeek = new Date(week);
    newWeek.setFullYear(event.target.value);
    newWeek.setHours(0, 0, 0, 0);
    return onWeekChange({
      week: newWeek
    });
  };

  var handleScroll = function handleScroll(event) {
    hoursRef.current.scrollTop = event.target.scrollTop;
    daysRef.current.scrollLeft = event.target.scrollLeft;
  };

  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_controls["default"], null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_arrowButton["default"], {
    onClick: selectPreviousWeek,
    variant: "border-filled",
    size: "small",
    disabled: isDisablePrevious,
    icon: /*#__PURE__*/_react["default"].createElement(_leftArrow["default"], null),
    assistiveText: "Previous Week"
  }), /*#__PURE__*/_react["default"].createElement(_title["default"], {
    "data-id": "week"
  }, formattedWeek), /*#__PURE__*/_react["default"].createElement(_arrowButton["default"], {
    onClick: selectNextWeek,
    variant: "border-filled",
    size: "small",
    disabled: isDisableNext,
    icon: /*#__PURE__*/_react["default"].createElement(_rightArrow["default"], null),
    assistiveText: "Next Week"
  })), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "select year",
    hideLabel: true,
    value: week.getFullYear(),
    options: yearsRange,
    onChange: handleYearChange
  })), /*#__PURE__*/_react["default"].createElement(_header["default"], {
    week: week,
    locale: locale,
    today: today,
    ref: daysRef
  }), /*#__PURE__*/_react["default"].createElement(_content["default"], null, /*#__PURE__*/_react["default"].createElement(_hours["default"], {
    locale: locale,
    ref: hoursRef,
    today: today,
    setToday: setToday
  }), /*#__PURE__*/_react["default"].createElement(_week["default"], {
    week: week,
    events: events,
    locale: locale,
    onEventClick: onEventClick,
    onScroll: handleScroll
  })), /*#__PURE__*/_react["default"].createElement(_gradient["default"], null));
}

WeeklyCalendar.propTypes = {
  /** An array that contains events that should be displayed on the calendar. */
  events: _propTypes["default"].array,

  /** Sets the date for the Calendar programmatically. */
  currentWeek: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string]),

  /** The ending of a range of valid dates. The range includes the endDate.
   * The default value is current date + 100 years. */
  maxDate: _propTypes["default"].instanceOf(Date),

  /** The beginning of a range of valid dates. The range includes the startDate.
   * The default value is current date - 100 years. */
  minDate: _propTypes["default"].instanceOf(Date),

  /** The Calendar locale. Defaults to browser's language. */
  locale: _propTypes["default"].string,

  /** Function triggered when week is changed */
  onWeekChange: _propTypes["default"].func,

  /** Function triggered when a event is clicked */
  onEventClick: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
WeeklyCalendar.defaultProps = {
  events: [],
  currentWeek: undefined,
  minDate: undefined,
  maxDate: undefined,
  onWeekChange: function onWeekChange() {},
  onEventClick: function onEventClick() {},
  locale: undefined,
  className: undefined,
  style: undefined
};